import React, { useState , useEffect, useContext} from 'react'
import './appointment.css'
import '../AffidavitTemp/affidavit.css'
import Sidebar from '../../../components/Sidebar/Sidebar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClockRotateLeft, faFileLines } from '@fortawesome/free-solid-svg-icons'
import { Link, useNavigate } from 'react-router-dom'
import BackLoader from '../../../components/backloader'
import * as Constants from '../../../constants';
import { ShareContext } from '../../../context/ShareContext'
import TopBar from '../../../components/topbar'
import moment from 'moment'
import JisAlert from '../../../components/jisalert'

function Appointment() {
    const { profile } = useContext(ShareContext);
    var url=`${Constants.apiUrl}/gazette/eswearing/${profile.username}`
    const [docs, setDocs] = useState([]);
    const [cases, setCases]=useState([]);
    const [refs, setRefs]=useState([]);
    const [isLoading,setIsLoading]= useState(false);
    const [schedule, setSchedule]= useState({});
    const [alert, setAlert] = useState({open:false})
    const [casetype, setCaseType] = useState('litigation');
    
    const dummyApts = [
        {
            title: 'MOTION EXPARTE',
            scheduledate: '2023-04-08',
            time: '02:05',
            meetinglink: 'https://us02web.zoom.us/j/85406241035?pwd=ZTZnV0pjejExbkdVRVZhdnQrTzZIQT09'
        },
        {
            title: 'Affidavit in Support of Motion',
            scheduledate: 'No scheduled date',
            time: 'Time not set',
            meetinglink: 'Meeting link yet to be created'
        },
        {
            title: 'MOTION EXPARTE',
            scheduledate: '2023-04-08',
            time: '02:05',
            meetinglink: 'https://us02web.zoom.us/j/85406241035?pwd=ZTZnV0pjejExbkdVRVZhdnQrTzZIQT09'
        },
        {
            title: 'MOTION EXPARTE',
            scheduledate: '2023-04-08',
            time: '02:05',
            meetinglink: 'https://us02web.zoom.us/j/85406241035?pwd=ZTZnV0pjejExbkdVRVZhdnQrTzZIQT09'
        },
        {
            title: 'Affidavit in Support of Motion',
            scheduledate: 'No scheduled date',
            time: 'Time not set',
            meetinglink: 'Meeting link yet to be created'
        },
        {
            title: 'MOTION EXPARTE',
            scheduledate: '2023-04-08',
            time: '02:05',
            meetinglink: 'https://us02web.zoom.us/j/85406241035?pwd=ZTZnV0pjejExbkdVRVZhdnQrTzZIQT09'
        },
        {
            title: 'Affidavit in Support of Motion',
            scheduledate: 'No scheduled date',
            time: 'Time not set',
            meetinglink: 'Meeting link yet to be created'
        },
        {
            title: 'MOTION EXPARTE',
            scheduledate: '2023-04-08',
            time: '02:05',
            meetinglink: 'https://us02web.zoom.us/j/85406241035?pwd=ZTZnV0pjejExbkdVRVZhdnQrTzZIQT09'
        },
        {
            title: 'MOTION EXPARTE',
            scheduledate: '2023-04-08',
            time: '02:05',
            meetinglink: 'https://us02web.zoom.us/j/85406241035?pwd=ZTZnV0pjejExbkdVRVZhdnQrTzZIQT09'
        },
        {
            title: 'Affidavit in Support of Motion',
            scheduledate: 'No scheduled date',
            time: 'Time not set',
            meetinglink: 'Meeting link yet to be created'
        }
    ]

    const [scheduleWindow, setScheduleWindow] = useState(false)

    const navigate = useNavigate();
    useEffect(() => {
        onLoad()
       
      }, []);


      useEffect(() => {
        if(casetype=='litigation'){
            onLoad();
        }else if (casetype=='adr'){
            onLoadAdr();
        }else if (casetype=='affidavit'){

        }
        onLoad()
       
      }, []);


      const onLoad= async()=>{
        //for account registration
        setCaseType('litigation');
        var url=`${Constants.apiUrl}/gazette/eswearing/${profile.username}`
        console.log(`the calling url ${url}`);
        try {
            setIsLoading(true);
            const resp = await fetch(url, { 
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': '',
              },
            });
            
            const data = await resp.json();
            if(data.code==0){

            }
            setIsLoading(false);
            console.log(data);
            if (data.code === 0) {
                setDocs(data.docs);
                setCases(data.cases);
                setRefs(data.refs);
               
            }else {    
                alert(data.status);
            }
          } catch (error) {
            setIsLoading(false);
            console.error(error);
            
          }
    }
    const onLoadAdr= async()=>{
        setCaseType("adr");
        var url=`${Constants.apiUrl}/gazette/adr/eswearing/${profile.username}`
        //for account registration
        console.log(`the calling url ${url}`);
        try {
            setIsLoading(true);
            const resp = await fetch(url, { 
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': '',
              },
            });
            
            const data = await resp.json();
            if(data.code==0){

            }
            setIsLoading(false);
            console.log(data);
            if (data.code === 0) {
                setDocs(data.docs);
                setCases(data.cases);
                setRefs(data.refs);
               
            }else {    
                alert(data.status);
            }
          } catch (error) {
            setIsLoading(false);
            console.error(error);
            
          }
    }

    const getTitle=(caseid)=>{
       var cc= cases.filter((c) => c.caseId ==caseid);
        if(cc.length==0)
         return 'N/A' 
        else
        return cc[0].caseTitle;
    }
    const getCaseNum=(caseid)=>{
        var cc= cases.filter((c) => c.caseId ==caseid);
         if(cc.length==0)
          return 'N/A' 
         else{
            var cnum=cc[0].caseNumber;
            var inf= cnum.indexOf('Temp');

           return inf==-1? cc[0].caseNumber:getCaseRef(caseid); 
         }
         
     } 
     
     const getCaseRef=(caseid)=>{
       
        var cc= refs?.filter((c) => c.caseId ==caseid);
         if(cc.length==0)
          return 'N/A' 
         else
         return cc[0]?.referenceNumber;
     }

     const onSaveSchedule=(doc)=>{
        
        console.log(schedule);
        var sch={docid:schedule.doc.id, zoomLink:schedule.zoom, scheduledBy:profile.username, scheduleDate : (schedule.date+' '+schedule.time)};

      
        const uploadurl=`${Constants.apiUrl}/gazette/schedule/${schedule.doc.id}`
        const formData = new FormData();
          

            // Sending the FormData using fetch
            setIsLoading(true);
            fetch(uploadurl, {
            method: 'POST',
            body: JSON.stringify(sch),
            headers: {
              'Content-Type': 'application/json',
              'Authorization': '',
            },
            })
            .then(response => response.json())
            .then(data => {
                setIsLoading(false);
                if(data.code==0){
                    //saved already
                    //first upldate the row and show dialog box
                    setDocs(docs.map(i => i.id === schedule.doc.id ? {...i, zoomLink:sch.zoomLink, schedule:sch.scheduleDate} : i));

                   setSchedule({});
                 
                   setAlert({open:true, title:'Schedule an Appointment', subtitle:'Meeting Schedule is successful', onOk})
                   setScheduleWindow(false)
                }
            })
            .catch(error => {
                console.error('Error:', error);
                setIsLoading(false);
        });
    }
    const onSelectSchedule=(doc)=>{
        setScheduleWindow(true);
        console.log(doc);
     
        setSchedule({...schedule, doc});
    }
    const onView=(item)=>{
        var a={...item,caseTitle: getTitle(item.caseId),caseNumber:getCaseNum(item.caseId), type:'user'   };
        if(item.doctumentType=='template'){
            navigate("/view-document-template", {state: {item:a}});
        }else{
            navigate("/view-document", {state: {item:a}});
        }
        
 }
 const onOk=()=>{
    setAlert({open:false});
}
  return (
    <div className='appointments'>
        <Sidebar />
        <div className="body">
            <TopBar title="Home/Appointments"/>
           
            <div className="aff-table">
                <div className="all-div">
                    <FontAwesomeIcon icon={faFileLines} />
                    <h3>All Appointments</h3>
                </div>
                <div style={{marginTop:16}}> <h3>{casetype=='litigation'?'Litigation Cases':casetype=='adr'?'ADR Cases':'Others'}</h3>
                <button className='planred' onClick={onLoad}>Litigation</button>
                <button className='planred' onClick={onLoadAdr}>ADR Cases</button>
            </div>
                <div className="table-wrapper">
                    <table>
                        <thead>
                            <tr>
                            <th>Suite Number</th>
                                <th> Title</th>
                                <th>Scheduled Date</th>
                                <th>Time</th>
                                <th>Meeting Link</th>
                              {(profile.role=='CommissionerForOaths' || profile.role=='e-CFO' || profile.role=='e-Commissioner for Oaths'  || profile.role=='ACR' || profile.role=='e-ACR') && <th>Reschedule </th>}
                                <th>View Document</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                docs.map((doc, i) => { return (
                                    <tr key={i}>
                                        <td>{getCaseNum(doc.caseId)}</td>
                                        <td>{getTitle(doc.caseId)}</td>
                                        <td> {doc.schedule!=null ? moment(doc.schedule).format("dddd, MMMM Do YYYY")  : 'No scheduled date'}</td>
                                        <td>{doc.schedule!=null ? moment(doc.schedule).format("h:mm a")  : 'Time not set'}</td>
                                        <td className={doc.schedule==null? '' :'meet-link'}>{doc.zoomLink!=null && <a href={doc.zoomLink} target='_blank'> Zoom Link </a>}  </td>
                                      {(profile.role=='CommissionerForOaths' || profile.role=='e-CFO'|| profile.role=='e-Commissioner for Oaths'  || profile.role=='ACR' || profile.role=='e-ACR') && 
                                      <td >  <button className='black'  onClick={() => onSelectSchedule(doc) }>{doc.schedule==null?'Schedule':'Reschedule' } </button></td>}    
                                       {/* <td className='schedule-zoom' onClick={() => onView(doc) } style={{color:'red'}}> View Document </td> */}
                                        <td > <button className='black'  onClick={() => onView(doc) }>View </button> </td>
                                    </tr>
                                )})
                            } 
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="footer-tech">
                <p>Powered By First Hightower InfoTech</p>
                <p>© 2024</p>
            </div>
            <div className={ scheduleWindow ? "pick-date open" : "pick-date"}>
                <div className="heading">
                    <h2>Appointment Details</h2>
                  
                </div>
               

                <input type="text" placeholder='Zoom Link' value={schedule.zoom} onChange={(e)=>setSchedule({...schedule, zoom:e.target.value})} />
              

                <input type="date" placeholder='Zoom meeting date' value={schedule.date} onChange={(e)=>setSchedule({...schedule, date:e.target.value})} />
                

                <input type="time" placeholder='Zoom meeting time' value={schedule.time} onChange={(e)=>setSchedule({...schedule, time:e.target.value})} />

               
                <div className="date-btns">
                    <button className="red" onClick={() => setScheduleWindow(false)}>Cancel</button>
                    <button className="black" onClick={onSaveSchedule }>Schedule Appointment</button>
                </div>
            </div>
          {alert.open && <JisAlert {...alert}/>}  
          <BackLoader open={isLoading}  />
        </div>
    </div>
  )
}

export default Appointment